import moment from 'moment'

export const isToday = someDate => {
    if (!someDate) return false
    const today = new Date()
    return (
        someDate.getDate() == today.getDate() &&
        someDate.getMonth() == today.getMonth() &&
        someDate.getFullYear() == today.getFullYear()
    )
}

export const getCurrentDate = () => {
    return new Date()
}

export const timeFromNow = (time, format = 'milliseconds') => {
    if (!time) return

    const startTime = moment(time)
    const timeFromNow = moment().diff(startTime, format)

    return timeFromNow
}

export const getTimeFromTimestamp = timestamp => {
    const date = new Date(timestamp)
    return date
        .toTimeString()
        .split(' ')[0]
        .slice(0, 5)
}
